// Carry Roll Unit boundary conversions — PSD §3 units boundary.
// Pure functions; all engine math happens in SI. Conversions only at the boundary.
export const M_PER_YD = 0.9144;
export const MS_PER_MPH = 0.44704;
export const MS_PER_KPH = 1 / 3.6;
export const M_PER_FT = 0.3048;
// ── Distance ──────
export const ydToM = (yd) => yd * M_PER_YD;
export const mToYd = (m) => m / M_PER_YD;
// ── Speed ──────
export const mphToMs = (mph) => mph * MS_PER_MPH;
export const msToMph = (ms) => ms / MS_PER_MPH;
export const kphToMs = (kph) => kph * MS_PER_KPH;
export const msToKph = (ms) => ms / MS_PER_KPH;
// ── Height ──────
export const ftToM = (ft) => ft * M_PER_FT;
export const mToFt = (m) => m / M_PER_FT;
// ── Angle ──────
export const degToRad = (deg) => (deg * Math.PI) / 180;
export const radToDeg = (rad) => (rad * 180) / Math.PI;
// ── Display formatters (round only at the boundary) ──────
export function formatDistance(m, unit) {
    if (!Number.isFinite(m))
        return '--';
    const value = unit === 'yd' ? mToYd(m) : m;
    return `${round(value, 0)} ${unit}`;
}
export function formatSpeed(ms, unit) {
    if (!Number.isFinite(ms))
        return '--';
    const value = unit === 'mph' ? msToMph(ms) : msToKph(ms);
    return `${round(value, 1)} ${unit}`;
}
export function formatHeight(m, unit) {
    if (!Number.isFinite(m))
        return '--';
    const value = unit === 'ft' ? mToFt(m) : m;
    return `${round(value, 0)} ${unit}`;
}
export function round(value, decimals) {
    const f = Math.pow(10, decimals);
    return Math.round(value * f) / f;
}
// Convert an SI metre value to the display distance unit (pure number, no rounding).
export function convertDistance(m, unit) {
    return unit === 'yd' ? mToYd(m) : m;
}
// Convert a display-unit distance value back to SI metres.
export function distanceToM(value, unit) {
    return unit === 'yd' ? ydToM(value) : value;
}
// Convert a display-unit speed value back to SI m/s.
export function speedToMs(value, unit) {
    return unit === 'mph' ? mphToMs(value) : kphToMs(value);
}
// Convert a display-unit height value back to SI metres.
export function heightToM(value, unit) {
    return unit === 'ft' ? ftToM(value) : value;
}
//# sourceMappingURL=units.js.map